<form (ngSubmit)="submit()" ngNativeValidate>
  <div class="radio-toolbar">
      <input type="radio" id="radio-1" name="reason" value="Spam" required
        [formControl]="reason"
      />
      <label for="radio-1">
        Spam
      </label>
      <input type="radio" id="radio-2" name="reason" value="Phishing" required
        [formControl]="reason"
      />
      <label for="radio-2">
        Phishing
      </label>
      <input type="radio" id="radio-3" name="reason" value="Malicious" required
        [formControl]="reason"
      />
      <label for="radio-3">
        Malicious
      </label>
      <input type="radio" id="radio-4" name="reason" value="Suspicious" required
        [formControl]="reason"
      />
      <label for="radio-4">
        Suspicious
      </label>
      <input type="radio" id="radio-5" name="reason" value="Porn" required
        [formControl]="reason"
      />
      <label for="radio-5">
        Porn
      </label>
      <input type="radio" id="radio-6" name="reason" value="DMCA" required
        [formControl]="reason"
      />
      <label for="radio-6">
        DMCA
      </label>
      <input type="radio" id="radio-7" name="reason" value="Other" required
        [formControl]="reason"
      />
      <label for="radio-7">
        Other
      </label>
  </div>
  <div class="input-container">
    <div class="input-with-action">
      <input
        type="text"
        id="reason"
        trans-placeholder
        placeholder="Provide a suspicious link..."
        [formControl]="link"
        required
      />
      <button
        type="submit"
        class="submit-button"
        mat-flat-button
        [disabled]="loading$ | async"
      >
        Submit
      </button>
    </div>
  </div>
  <span class="message">
    <p 
      *ngIf="message"
    >
      <mat-icon svgIcon="info"></mat-icon> {{ message }}  
    </p>
  </span>
</form>
